import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography } from "@mui/material"
import { useFormik } from "formik"
import * as yup from "yup"
import FileUploadField from "../../components/FileUploadField"
import { dialogModes } from "../../constants"
import { useState } from "react"

const getTitle = (mode) => {
    switch (mode) {
        case dialogModes.CREATE:
            return "Создание плана"
        case dialogModes.UPDATE:
            return "Редактирование плана"
        default:
            return ""
    }
}

const PlanForm = ({ data, onSubmit, open, onClose, mode }) => {

    const { values, errors, touched, handleChange, setFieldValue, handleSubmit } = useFormik({
        initialValues: {
            name: data?.name,
            file: data?.file ? [data.file] : []
        },
        enableReinitialize: true,
        validationSchema: yup.object({
            name: yup.string().required("Обязательное поле"),
            file: yup.mixed().required("Обязательное поле").nonNullable("Выберите файл"),
        }),
        onSubmit: values => {
            onSubmit({ ...values, file: values.file[0] })
        }
    })

    if (!data || !values) return null

    return <Dialog open={open} onClose={onClose} fullWidth>

        <DialogTitle>
            {getTitle(mode)}
        </DialogTitle>

        <DialogContent>
            <TextField
                id="name"
                name="name"
                label="Название"
                value={values.name}
                onChange={handleChange}
                error={touched.name && Boolean(errors.name)}
                helperText={touched.name && errors.name}
                fullWidth
            />

            <FileUploadField
                maxFiles={1}
                nameGetter={x => x?.name ?? ""}
                typeGetter={x => x?.type ?? ""}
                acceptedFiles={values.file}
                onRemoveAcceptedFile={() => setFieldValue("file", null)}
                onDrop={acceptedFiles => setFieldValue("file", [acceptedFiles[0]].filter(x => x))}
                maxSize={5}
            />
            {(touched.file && Boolean(errors.file)) && <Typography align="center" color="error">{errors.file}</Typography>}
        </DialogContent>

        <DialogActions>
            <Button onClick={handleSubmit}>
                Сохранить
            </Button>
            <Button color="error" onClick={handleSubmit}>
                Закрыть
            </Button>
        </DialogActions>
    </Dialog>
}

export default PlanForm